module.exports = __webpack_public_path__ + "static/media/shape_portal2.d7cbc042.svg";